import React, {useState, useEffect} from 'react';

import {Card, Row, Col, Statistic, Table, Skeleton, DatePicker, Button} from 'antd';
import {Estoque} from '../../componentes';
import { useAxios } from '../../hooks';
import * as moment from 'moment';


import { FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {faInventory, faFileInvoice, faCalendar} from '@fortawesome/pro-duotone-svg-icons'
const { RangePicker } = DatePicker;

const mokeData = {
    "estoqueMinimo": {
        "produtos": [
            
        ]
    },
    "lotesAVencer": {
        "dados":[],
        "quantidade": 0
    },
    "nfes": {
        "total": 0,
        "nfes": [
           
        ]
    }
};

const useDashboard = () => {

    const {getApiEmitirNotas} = useAxios();

    const loadDashboard = async (setDados, ateVcto) => {

        const api = await getApiEmitirNotas();
        const result = await api.get('/produtos/v2/dashboard',{
            params: {ateVcto}
        });
        return result.data;
        
    }

    return {loadDashboard};

}
const PaginaInicial = () => {

   

    const [dados, setDados] = useState(mokeData);
    const [loading, setLoading] = useState(false);

    const {loadDashboard} = useDashboard();

    // const [deVcto, setDeVcto] = useState(moment());
    const [ateVcto, setAteVcto] = useState(moment().add(3, 'months'));

    // console.log("de: ",deVcto.format("DD/MM/YYYY"));
    console.log("ate: ",ateVcto.format("DD/MM/YYYY"));

    const BaixarListaHandle = () => {
        let strArquivo = `"Codigo";"Descricao";"Validade";"Quantidade"\n`;
        dados.lotesAVencer.dados.map(produto => {
            console.log(produto)
            let {codigo, descricao, validade, saldoEstoque} = produto;
            validade = moment(validade).format("DD/MM/YYYY");
            strArquivo += `"# ${codigo}";"${descricao}";"\t${validade}";"${saldoEstoque}"\n`;
        });
        const base64File = Buffer.from(strArquivo).toString("base64");
        
        const a = document.createElement("a");
        a.href = `data:application/vnd.ms-excel;base64,${base64File}`;
        a.download="produtos-a-vencer.csv";
        a.click();
        // setTimeout(()=> {
        //     document.removeChild(a);
        // })
    }

    const _loadDashboard = async () => {
        setLoading(true);
        console.log("loading");
        const dados = await loadDashboard(setDados, ateVcto.format("YYYY-MM-DD"));
        setDados(dados);
        setLoading(false);
    }
    useEffect(() => {
        _loadDashboard();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // useEffect(() => {
    //     document.title = "Gestão de estoque - Contentsys";
    // }, []);

    const buscarItensVencidosHandle = async () => {
        _loadDashboard();
    }

    const columnsLotesAVencer = [
        {
            title: 'Codigo',
            dataIndex: 'codigo',
            key: 'codigo',
        },
        {
            title: 'Descricao',
            dataIndex: 'descricao',
            key: 'descricao',
        },
        {
            title: 'Em Estoque',
            dataIndex: 'saldoEstoque',
            key: 'saldoEstoque',
            render: (data, value)=>{
                return <Estoque value={ data } unMedida={" " + value.uCom}></Estoque>
            }
        },
        {
            title: 'Validade',
            dataIndex: 'validade',
            key: 'validade',
            render: (data, value) => {
                return moment(data).format("DD/MM/YYYY");
    
            }
        },
    ];

    const changeRangeVctoHandle = (evt)=> {
        console.log(evt);
        setAteVcto(evt);
        
    }

    
    const columns = [
    {
        title: 'Codigo',
        dataIndex: 'codigo',
        key: 'codigo',
    },
    {
        title: 'Descricao',
        dataIndex: 'descricao',
        key: 'descricao',
    },
    {
        title: 'Em Estoque',
        dataIndex: 'saldoEstoque',
        key: 'saldoEstoque',
        render: (data, value)=>{
            return <Estoque value={ data } unMedida={" " + value.uCom}></Estoque>
        }
    },
    {
        title: 'Minimo',
        dataIndex: 'estoqueMinimo',
        key: 'estoqueMinimo',
        render: (data, value) => {
            return <Estoque value={ data } unMedida={" " + value.uCom}></Estoque>

        }
    },
    ];
    return(<div style={{
        padding: "23px"
    }}>

        <h1 style={{
            textAlign: "left"
        }}>Dashboard</h1>



        

            <Row gutter={24}>
                <Col span={8}>
                    <Card>
                        <Skeleton loading={loading}>
                            <Statistic title="Estoque Baixo" value={dados.estoqueMinimo.produtos.length} prefix={<FontAwesomeIcon icon={faInventory} />} />
                        </Skeleton>
                    </Card>
                </Col>
                <Col span={8}>
                    <Card>
                        <Skeleton loading={loading}>
                            <Statistic title="Vencimento Próximo" value={dados.lotesAVencer.quantidade} prefix={<FontAwesomeIcon icon={faCalendar} />} />
                        </Skeleton>
                    </Card>
                </Col>
                <Col span={8}>
                    <Card>
                        <Skeleton loading={loading}>
                            <Statistic title="Notas a Receber" value={dados.nfes.total}  prefix={<FontAwesomeIcon icon={faFileInvoice} />} />   
                        </Skeleton>
                    </Card>
                </Col>
            </Row>

            <Row gutter={24} style={{
                marginTop: '23px'
            }}>
                <Skeleton loading={loading}>
                    <Col span={12} style={{
                        
                    }}>
                        <h1 style={{
                            textAlign: "left"
                        }}>Produtos com Estoque Baixo</h1>
                            <Table columns={columns} dataSource={dados.estoqueMinimo.produtos}></Table>
                                
                        
                    </Col>

                    <Col span={12} style={{
                        
                    }}>
                        <h1 style={{
                            textAlign: "left"
                        }}>Produtos com Vencimento Próximo
                        </h1>
                        <span style={{"display": "block", "textAlign": "left"}}>
                            Vencimentos Até: <DatePicker format="DD/MM/YYYY" defaultValue={ateVcto} onChange={changeRangeVctoHandle}></DatePicker>
                            <Button onClick={buscarItensVencidosHandle}>Buscar</Button>
                            <Button onClick={BaixarListaHandle}>Baixar Lista</Button>
                        </span>
                            
                            <Table columns={columnsLotesAVencer} dataSource={dados.lotesAVencer.dados}></Table>
                                
                        
                    </Col>
                </Skeleton>
                
            </Row>
        

    </div>
    );
}

export {PaginaInicial};